/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component} from '@angular/core';
import {AuthService, I18nService, MY_ACCOUNT} from '../../_services/services';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGIC METHODS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public authService: AuthService, private i18n: I18nService) {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get fullName(): string {
    if (this.userFirstName && this.userLastName) {
      return `${this.userFirstName} ${this.userLastName}`;
    }

    if (this.userFirstName) {
      return this.userFirstName;
    }

    if (this.userLastName) {
      return this.userLastName;
    }

    return this.i18n.get(MY_ACCOUNT);
  }

  get userFirstName(): string | null {
    return this.authService.currentUser && this.authService.currentUser.firstname ? this.authService.currentUser.firstname : null;
  }

  get userLastName(): string | null {
    return this.authService.currentUser && this.authService.currentUser.lastname ? this.authService.currentUser.lastname : null;
  }

}
